import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import style from './ui-tabs.css?inline';

const CName = 'ui-tabs';

/**
 * @prop {string[]} tabs - The tabs to display
 * @prop {string|undefined} selectedTab
 * @prop {Function} onTabClickCb - The callback to execute when a tab is clicked
 */
@customElement(CName)
export class UiTabs extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: Array }) tabs: string[];
  @property({ type: String }) selectedTab: string | undefined;
  @property({ type: Array }) onTabClickCb: (id: string) => void;
  @property({ type: Boolean }) incentiveStyle = false;

  render() {
    if (!this.tabs || this.tabs.length === 0) {
      return nothing;
    }
    return html`
      <div class=${`ui-tabs ${this.incentiveStyle ? 'ui-tabs--incentive' : ''}`}>
        ${
          this.tabs.length === 1
            ? html`
                <h2 class="ui-tabs__tab ui-tabs__tab--selected ui-tabs__tab--single">${this.tabs[0]}</h2>
              `
            : repeat(
                this.tabs,
                (tab) =>
                  html`
                    <button
                      class=${`ui-tabs__tab ${tab === this.selectedTab ? 'ui-tabs__tab--selected' : ''}`}
                      @click=${() => this.onTabClickCb(tab)}
                      aria-label=${window.$app.$t.get(I18n.a11y.button.tab)}
                    >${tab}</button>
                  `,
              )
        }
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiTabs;
  }
}
